<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="https://twitter.com/keiba_uma_ai">
            Twitter
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.youtube.com/channel/UCBs7L_vsWJCI86uovPtgzXg">
            Youtube
          </a>
        </li>
      </ul>
      <div class="copyright">
        © {{year}} Masa_Charcoal / Ummy
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
